<div class="popup">
    <p *ngIf="success == true" class="success-popup">Saved!</p>
    <p *ngIf="success == false" class="reject-popup">{{errorMessage}}</p>
</div>
<div class="container">
    <div class="row">
        <div class="col main">
            <form [ngStyle]="{ height: windowWidth}">
                <ngx-stripe-card-group [formGroup]="stripeTest" [elementsOptions]="elementsOptions">
                    <p class="heading">Change Payment Mode</p>
                    <div>
                        <input type="text" formControlName="name" class="name-input" placeholder="Name on card"
                            (focus)="foundError = false" />
                    </div>
                    <div class="card-number">
                        <ngx-stripe-card-number [options]="cardOptions" (focus)="foundError = false">
                        </ngx-stripe-card-number>
                    </div>
                    <div class="card-details">
                        <div class="card-expiry">
                            <ngx-stripe-card-expiry [options]="cardOptions" (focus)="foundError = false">
                            </ngx-stripe-card-expiry>
                        </div>
                        <div class="card-cvc">
                            <ngx-stripe-card-cvc [options]="cardOptions" (focus)="foundError = false">
                            </ngx-stripe-card-cvc>
                        </div>
                    </div>
                    <div class="save-div">
                        <button class="save" type="submit" (click)="createCard()">
                            <span *ngIf="isloading" class="spinner-border spinner-border-sm" role="status"
                                aria-hidden="true"></span>
                            Change Payment Info
                        </button>
                        <p><a (click)="cancelClick()">Or Cancel</a></p>
                    </div>
                </ngx-stripe-card-group>
                <p *ngIf="foundError" class="error" id="error">{{errorMessage}}</p>
            </form>
        </div>
    </div>
</div>